import React from "react";
import AbmasMenu from "../components/menu/general/AbmasMenu";

const TabelPengabdian = () => {
  return <AbmasMenu />;
};
export default TabelPengabdian;
